import Validators from 'redux-form-validators'
import validCC from 'card-validator';

const DEFAULT_ERROR_MESSAGES = {
  presence: 'Required',
  email: 'Invalid email',
  wrongLength: 'Must be {count, number} {count, plural, one {character} other {characters}}',
  tooLong: 'Must be less than {count, number} {count, plural, one {character} other {characters}}'
};

let originalFormatMessage = Validators.formatMessage
Validators.formatMessage = (msg) => {
  if (msg.id) {
    let type = msg.id.split('.').pop();
    msg.defaultMessage = DEFAULT_ERROR_MESSAGES[type] || msg.defaultMessage;
  }
  return originalFormatMessage(msg)
}


// CUSTOM VALIDATORS
export const isValidCCDate = value => !validCC.expirationYear(value).isPotentiallyValid ? 'Invalid year' : '';
export const isValidCCMonth = value => !validCC.expirationMonth(value).isPotentiallyValid ? 'Invalid month' : '';
export const isValidCCNumber = value => {
  var ccNumberValidation = validCC.number(value);
  return !ccNumberValidation.isPotentiallyValid ? 'Invalid credit card number' : '';
};
export const isValidPostalCode = value => !validCC.postalCode(value).isPotentiallyValid ? 'Invalid zipcode' : '';

// Was not working.  REF https://github.com/gtournie/redux-form-validators
// export const ccNumberValidator = addValidator({
//   validator: function (options, value, allValues) {
//     var ccNumberValidation = validCC.number(value);
//     if (!ccNumberValidation.isPotentiallyValid) {
//       console.log('ccNumberValidation: ', ccNumberValidation)
//       return {
//         id: "form.errors.invalidCCNumber",
//         defaultMessage: "Invalid CC number",
//         values: {}
//       }
//     }
//   }
// });



// WEBPACK FOOTER //
// ./src/config/validation.js